module.exports = __webpack_public_path__ + "static/media/addItemsToRefill2.1443d130.png";